import apiClient from "./axiosClient";

export async function login({email, password}) {
  return apiClient.post("/jwt/auth/login/", {email, password});
}

// Логаут
export async function logout() {
  return apiClient.post("/jwt/auth/logout/");
}

// Проверить профиль / получить пользователя
export async function getProfile() {
  return apiClient.get("/user/profile/");
}

export async function updateAccess() {
  return apiClient.post("/jwt/auth/refresh/")
}